import { ElementType } from 'react'
import CreationToolWelcomeButton from 'creation/src/creation-tools/types/welcome-button'
import { AddMoreIcon, GifIcon, StickerIcon, SuperCutIcon, VideoIcon } from '../components/icons'

const icons: Record<CreationToolWelcomeButton, ElementType> = {
    [CreationToolWelcomeButton.Gif]: GifIcon,
    [CreationToolWelcomeButton.Upload]: GifIcon,
    [CreationToolWelcomeButton.Sticker]: StickerIcon,
    [CreationToolWelcomeButton.UploadSticker]: StickerIcon,
    [CreationToolWelcomeButton.UploadVideo]: VideoIcon,
    [CreationToolWelcomeButton.SuperCut]: SuperCutIcon,
    [CreationToolWelcomeButton.UploadAddMore]: AddMoreIcon,
}

export const welcomeButtonIcon = (button: CreationToolWelcomeButton): ElementType => icons[button]

export default CreationToolWelcomeButton
